// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';

class QuoteBox {
	constructor(el) {
		// Classes
		this.activeClass = 'elearning-pertussis-case-study__quotebox__answer--reveal';

		// Elements
		this.$el = $(el);
		this.$contenteditable = this.$el.find('.elearning-pertussis-case-study__quotebox__contenteditable');
		this.$answer = this.$el.find('.elearning-pertussis-case-study__quotebox__answer');
		this.$textarea = this.$el.find('.elearning-pertussis-case-study__quotebox__textarea');

		this.attachEvents();

		this.$el.data('init', true);
	}

	attachEvents() {
		this.$contenteditable.on('blur', () => {
			console.log(this.$contenteditable.text());
			this.$answer.toggleClass(this.activeClass, this.$contenteditable.text() !== '');
			this.$textarea.text(this.$contenteditable.text());
		});
	}
}

export default QuoteBox;

const _init = () => {
	// Elements
	let $el = $('.quotebox');
	if ($el.length) {
		$el.each((e, v) => {
			if (!$(v).data('init')) {
				new QuoteBox($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function () {
	_init();
});
